import loadable from '@loadable/component';

export const AuthLoginPageLoadable = loadable(() => import('./AuthLoginPage'), {
  resolveComponent: (module) => module.AuthLoginPage,
});
